import { render } from "./MiezzCustomsProduct.vue?vue&type=template&id=3b0a1a2c&scoped=true&ts=true"
import script from "./MiezzCustomsProduct.vue?vue&type=script&lang=ts"
export * from "./MiezzCustomsProduct.vue?vue&type=script&lang=ts"

import "./MiezzCustomsProduct.vue?vue&type=style&index=0&id=3b0a1a2c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0a1a2c"]])

export default __exports__